.header {
  margin-bottom: var(--spacing-6);
  text-align: left;
}

/* Edit affordance: hidden until the title row is hovered, or the button
   itself holds keyboard focus — it stays tabbable while invisible. */
.editButton {
  opacity: 0;
  transition: opacity 0.15s ease;
}

.titleRow:hover .editButton,
.titleRow:focus-within .editButton {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .editButton {
    transition: none;
  }
}
